import { render, staticRenderFns } from "./PaymentMethodRedirect.vue?vue&type=template&id=bfa4e112&"
import script from "./PaymentMethodRedirect.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports